<template>
    <div class="main-content" id="calendar">
        <PageTitle main-title="Planning" sub-title="See how your posts are distributed over time" av-icon="calendar"></PageTitle>
        <div class="row">
            <div class="col-md-12">
                <card card-title="Content calendar" content-spacing="half-sides">
                    <template v-slot:card-actions>
                        <ButtonGroup><Button variant="neutral"><svgicon name="list"></svgicon> List</Button><Button variant="neutral"><svgicon name="calendar"></svgicon> Calendar</Button></ButtonGroup>
                    </template>
                    <Schedule></Schedule>
                </card>
            </div>
        </div>
    </div>
</template>
<script>
    import Card from "../../components/Card/Card";
    import PageTitle from "../../components/Pagetitle/Pagetitle";
    import Schedule from "../../components/Schedule/Schedule";
    import Button from "../../components/Button/Button";
    import ButtonGroup from "../../components/ButtonGroup/ButtonGroup";

    export default {
        name: 'calendar',
        components: {
            PageTitle,
            Card,
            Schedule,
            Button,
            ButtonGroup
        },
        props: [],
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {
            this.scroll();
        },
        methods: {
            scroll () {
                window.addEventListener('scroll', () => {
                    const scrollY = window.scrollY+100;
                    const visible = document.documentElement.clientHeight;
                    const pageHeight = document.documentElement.scrollHeight;
                    const bottomOfPage = visible + scrollY >= pageHeight
                    console.log(bottomOfPage || pageHeight < visible);
                });
            },
        }
    }

</script>
<style src="./Calendar.scss" scoped lang="scss"></style>

